import { Card, CardContent } from '@/components/ui/card';
import { Users, Clock } from 'lucide-react';

export default function AdvisoryBoardPage() {
  return (
    <div data-testid="advisory-board-page">
      <section className="bg-[#1B2A4A] py-16 md:py-20">
        <div className="imcac-container">
          <p className="imcac-overline mb-3">Leadership</p>
          <h1 className="text-4xl sm:text-5xl font-bold text-white tracking-tight font-heading">Advisory Board</h1>
          <div className="h-1 w-20 bg-[#C5A572] mt-5" />
          <p className="text-lg text-slate-300 mt-4 max-w-2xl">
            The IMCAC Advisory Board comprises distinguished medical professionals and academics from across the globe, providing strategic oversight and expert guidance.
          </p>
        </div>
      </section>

      <section className="imcac-section bg-white">
        <div className="imcac-container max-w-3xl">
          <Card className="border-slate-200">
            <CardContent className="p-12 text-center">
              <div className="w-16 h-16 bg-[#1B2A4A]/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <Users className="h-8 w-8 text-[#1B2A4A]" />
              </div>
              <h2 className="text-2xl font-bold text-[#1B2A4A] font-heading mb-3">
                Advisory Board Members
              </h2>
              <div className="flex items-center justify-center gap-2 text-[#C5A572] mb-4">
                <Clock className="h-4 w-4" />
                <span className="text-sm font-medium">Coming Soon</span>
              </div>
              <p className="text-slate-600 max-w-md mx-auto">
                The complete list of IMCAC Advisory Board members will be published shortly. 
                Our board comprises leading experts in aesthetic medicine, medical education, 
                and clinical governance from around the world.
              </p>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
}
